module.exports = __webpack_public_path__ + "static/media/twitter.0251d8ee.png";